import scrollTo from '../helpers/scrollTo';
import gsap from 'gsap';
import customPageScroll from '../components/custom-scroll';
import {IS_TABLET_SM} from "../helpers/consts";

export default () => {
	const wrapper = document.querySelector('.single-post');
	if (!wrapper) return;

	const links = wrapper.querySelectorAll('a[href^="#"]');

	links.forEach((link) => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			const href = link.getAttribute('href');
			const target = document.querySelector(href);
			if (!target) return;

			const rect = target.getBoundingClientRect();
			scrollTo(0, customPageScroll.scrollY + rect.top, 700);
		});
	});


	// Sticky table of contents
	// Sticky table of contents
	const toc = document.querySelector('.oob_toc');

// Function to check screen size
	function isMobile() {
		return window.matchMedia("(max-width: 767px)").matches;
	}

// Only run GSAP if TOC exists and screen is above 768px
	if (toc && !isMobile()) {
		gsap.to(toc, {
			scrollTrigger: {
				trigger: ".article-layout__toc",
				start: "top 120px", // Start when the TOC top hits 120px from viewport top
				end: () => `bottom-=${toc.offsetHeight + 60}px`, // Dynamically calculated end point
				pin: true,
				pinSpacing: false,
				scrub: true,
				markers: false // Set to true for debugging
			}
		});
	}


};
